
window.creations = new (function () {
    this.index = function () {


    }
    this.details = function () {

    }

});


